import { Formik, FormikErrors, FormikProps } from 'formik';
import { MutableRefObject, memo } from 'react';
import PhoneNumberForm from '../../../../../../shared/components/PhoneNumberForm';
import { courseTypeDescription } from '../../../../helpers';
import { Product } from '../../../../models';
import AddressForm from '../../ProfileUpdateModal/AddressForm';
import {
  ProfileModel,
  RedemptionProfile,
} from '../../ProfileUpdateModal/models';
import { initialProfileValues } from '../helpers';
import styles from '../enhancedEnrollmentModal.module.scss';

interface ProfileUpdateSectionProps {
  productType: Product['type'];
  formikRef: MutableRefObject<FormikProps<ProfileModel> | undefined>;
  requestPhoneInfo: boolean;
  requestAddressInfo: boolean;
  userRedemptionProfile: RedemptionProfile;
  onProfileFormSubmit: (values: ProfileModel) => Promise<void>;
  validateProfile: (values: ProfileModel) => FormikErrors<ProfileModel>;
  onCountryRestricted: (isRestricted: boolean) => void;
}

function ProfileUpdateSection({
  productType,
  formikRef,
  requestPhoneInfo,
  requestAddressInfo,
  userRedemptionProfile,
  onProfileFormSubmit,
  validateProfile,
  onCountryRestricted,
}: ProfileUpdateSectionProps) {
  const courseTypeText = courseTypeDescription(productType);

  return (
    <div className={`d-block mt-3 pt-3 ${styles.profileUpdateBlock}`}>
      <h5>Additional Information Required</h5>
      <p>
        To access this {courseTypeText} please add the following information,
        which will be saved to your PMI Profile.
      </p>
      <Formik
        initialValues={initialProfileValues}
        onSubmit={onProfileFormSubmit}
        validate={validateProfile}
        validateOnBlur={false}
        validateOnChange={false}
        innerRef={formikRef}
      >
        <>
          {requestPhoneInfo && (
            <PhoneNumberForm
              countries={
                userRedemptionProfile?.phoneNumbers?._embedded?.countries
              }
            />
          )}

          {requestAddressInfo && (
            <AddressForm
              countries={userRedemptionProfile?.addresses?._embedded?.countries}
              onCountryRestricted={onCountryRestricted}
            />
          )}
        </>
      </Formik>
    </div>
  );
}

export default memo(ProfileUpdateSection);
